import { render, staticRenderFns } from "./PacklistRoot.vue?vue&type=template&id=5946fff8"
import script from "./PacklistRoot.vue?vue&type=script&lang=js"
export * from "./PacklistRoot.vue?vue&type=script&lang=js"
import style0 from "./PacklistRoot.vue?vue&type=style&index=0&id=5946fff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports